
// firebase.js
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

// const firebaseConfig = {
//   apiKey: "AIzaSyAxMYJzqGC7E0f5WVauiOSmgU6tU-XZOGI",
//   authDomain: "reservika-c60ea.firebaseapp.com",
//   projectId: "reservika-c60ea",
//   storageBucket: "reservika-c60ea.firebasestorage.app",
//   messagingSenderId: "720536734474",
//   appId: "1:720536734474:web:049c8ed2e906fb308208f3"
// };

const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Auth, Firestore, Storage
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Messaging (optional)
const messagingPromise = isSupported().then(supported => supported ? getMessaging(app) : null);

// Cloud Functions
const functions = getFunctions(app, "europe-west3"); // region optional, falls du DE-Funktionen hast

export { app, auth, db, storage, messagingPromise, functions };
